/* Nutravel homepage sections: tabs, add to cart, reveal.
   Loaded with `defer` by every nv-* section; guarded so it runs once. */
(() => {
  if (window.__nvHome) return;
  window.__nvHome = true;
  document.documentElement.classList.add('nv-js');

  /* ---------- Reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window && new IntersectionObserver(entries => entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -10% 0px' });
  const watch = root => root.querySelectorAll('.nv-reveal:not(.is-in)').forEach(el => io ? io.observe(el) : el.classList.add('is-in'));
  watch(document);

  /* ---------- Shop by concern tabs ---------- */
  document.addEventListener('click', e => {
    const tab = e.target.closest('.nv-chip[role="tab"]');
    if (!tab) return;
    const root = tab.closest('.nv-shop');
    root.querySelectorAll('.nv-chip[role="tab"]').forEach(t => {
      const on = t === tab;
      t.setAttribute('aria-selected', on);
      t.tabIndex = on ? 0 : -1;
      document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
    });
  });
  // Arrow keys move between tabs, as people expect from a tab list.
  document.addEventListener('keydown', e => {
    const tab = e.target.closest('.nv-chip[role="tab"]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
    const tabs = [...tab.parentElement.querySelectorAll('[role="tab"]')];
    let i = tabs.indexOf(tab);
    i = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    tabs[i].focus(); tabs[i].click(); e.preventDefault();
  });

  /* ---------- Add to cart ----------
     Forms post to /cart/add and work without JS. With JS we stay on the page,
     confirm in the button, and refresh whichever cart the store uses. */
  async function refreshCart() {
    // Shiprocket mini cart (installed on nutravel.in)
    if (typeof window.updateMiniCartSection === 'function') {
      try { await window.updateMiniCartSection(); } catch (_) {}
      // Open it the same way the header's cart icon does.
      const icon = document.getElementById('cart-icon-bubble-sr');
      if (icon) icon.click();
      return;
    }
    // Theme's own cart drawer (Dawn family)
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      const res = await fetch(`${(window.routes && window.routes.cart_url) || '/cart'}?sections=cart-drawer,cart-icon-bubble`);
      const sections = await res.json();
      drawer.renderContents({ sections });
      return;
    }
    // Fallback: update the cart count bubble if the theme has one
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      const res = await fetch('/?sections=cart-icon-bubble');
      const html = (await res.json())['cart-icon-bubble'];
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (next) bubble.innerHTML = next.innerHTML;
    }
  }

  document.addEventListener('submit', async e => {
    const form = e.target.closest('form.nv-add');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button');
    const label = btn.textContent;
    const status = form.querySelector('.nv-status');
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: 1 }] }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
      btn.textContent = 'Added';
      btn.classList.add('is-done');
      if (status) status.textContent = `${btn.dataset.name || 'Item'} added to your bag.`;
      await refreshCart();
    } catch (err) {
      btn.textContent = 'Try again';
      if (status) status.textContent = err.message;
    } finally {
      btn.removeAttribute('aria-busy');
      setTimeout(() => { btn.textContent = label; btn.classList.remove('is-done'); }, 1600);
    }
  });

  /* ---------- Theme editor: re-run when a section is added or changed ---------- */
  document.addEventListener('shopify:section:load', e => watch(e.target));
})();
